module.exports = __webpack_public_path__ + "img/61e2607961fee2a8fb0ce26c429cf530.png";